<script setup lang="ts">
import { useTradingStore } from '@/stores/trading'
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'

const tradingStore = useTradingStore()

onMounted(() => {
  tradingStore.initialize()
})
</script>

<template>
  <div class="min-h-screen bg-bg-primary text-text-primary">
    <RouterView />
  </div>
</template>
